export default __webpack_public_path__ + "static/media/computree.59ae3896.webp";